import { AnnotationClient, AnnotableDocumentClient, EditAnnotationDto } from '@greatmindsorg/annotations-sdk';
import { Error } from '@insync-students-lib/models/error/error.model';
import { getAnnotationsServiceInstanceOptions } from '@insync-students-utils/apiConfig';
export interface IAnnotationsServiceError {
  status: number;
  statusText: string;
}
export class AnnotationsService {
  static newInstance(options?, retryOptions?): AnnotationsService {
    const instanceOptions = getAnnotationsServiceInstanceOptions(options);
    return new AnnotationsService(AnnotationClient.newInstance(instanceOptions, retryOptions), AnnotableDocumentClient.newInstance(instanceOptions, retryOptions));
  }
  public annotationClient: AnnotationClient;
  public annotableDocumentClient: AnnotableDocumentClient;
  constructor(annotationClient?: AnnotationClient, annotableDocumentClient?: AnnotableDocumentClient) {
    this.annotationClient = annotationClient;
    this.annotableDocumentClient = annotableDocumentClient;
  }

  /**
   * get Annotable Document by ID;
   */
  getAnnotableDocument = async (id: string) => {
    try {
      const response = await this.annotationClient.findByAnnotableDocument(id);
      return response;
    } catch (err) {
      const error = err as unknown as IAnnotationsServiceError;
      throw new Error({
        status: error.status,
        message: error.statusText
      });
    }
  };

  /**
   * Get Annotable Document by ID;
   */
  findByContentId = async (ids: string[], parentId?: string, parentType?: string, resourceId?: string) => {
    try {
      const response = await this.annotableDocumentClient.findByContentId(ids, parentId, parentType, resourceId);
      return {
        ...response,
        data: response.data
      };
    } catch (err) {
      const error = err as unknown as IAnnotationsServiceError;
      throw new Error({
        status: error.status,
        message: error.statusText
      });
    }
  };

  /**
   * Save documment annotations;
   */
  saveAnnotations = async (params: EditAnnotationDto[]) => {
    try {
      const response = await this.annotationClient.save(params);
      return response;
    } catch (err) {
      const error = err as unknown as IAnnotationsServiceError;
      throw new Error({
        status: error.status,
        message: error.statusText
      });
    }
  };
}